// extracted by mini-css-extract-plugin
export default {"container":"TeacherDetails_container__5SCz0","title":"TeacherDetails_title__zAT6y","table":"TeacherDetails_table__jxkRd"};